module.exports = __webpack_public_path__ + "img/NodeJS.c8e310dc.png";